

var stagingSettings = {
    infrecReplication: function (catalogId) {
        var className = 'ajax/Administration/Infrec/replication';
        var postData = {catalogId: catalogId};

        $('#updateStatus').html('Update in progress. This can take a while....');
        var callback = function (data) {
            $('#updateStatus').html('Update sucessfull ' + data);
        };
        var callbackFail = function (data) {
            $('#updateStatus').html(data.responseJSON._ajax_exception);
        };
        AjaxHandlerByClass(className, postData, callback, callbackFail);
    }
}